module.exports = __webpack_public_path__ + "img/Jingdong-back.d8bae01c.png";